import React from "react";

export default function PulseIQSection() {
  return (
    <section className="flex flex-col md:flex-row items-center justify-between max-w-4xl mx-auto gap-10">
      {/* LEFT TEXT SECTION */}
      <div className="flex flex-col self-start md:self-auto">
        <div className="font-bebas font-normal tracking-wider text-[30px] lg:text-[50px] leading-[130%] text-[#06382f] mb-6">
          <span className="text-[#0E8A43]">PulseIQ</span> — <br />
          <span>Bring Back the Best</span>
        </div>

        <ul className="text-[#004D4D] text-base lg:text-lg font-inter font-medium leading-[130%] space-y-6 pl-5 list-disc mb-6">
          <li>Contextual summarizing each day</li>
          <li>Related tags & contextual clusters</li>
          <li>Scrollable format = ongoing re-engagement</li>
        </ul>

        <div className="text-[#004D4D] text-lg md:text-[20px] font-medium font-inter">
          Give your best content a second life.
        </div>
      </div>

      {/* RIGHT VIDEO SECTION */}
      <div className="w-full max-w-[350px]">
        <video
          src="./pulseIQ.mov"
          controls
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-auto object-cover"
        />
      </div>
    </section>
  );
}
